module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/018-6cc6fb92c0da05cd14a2307bbe3574ed.jpg";